import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { addTareaSuccess } from "../features/tareaSlice";
import { BACKEND } from "../config/configEnvs";

const NuevaTarea = () => {
  const navigate = useNavigate();
  const [tarea, setTarea] = useState("");
  const [marca, setMarca] = useState("");
  const [fechaLimite, setFechaLimite] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const user = useSelector((state) => state.auth.user);
  console.log(user);

  const handleTareaChange = (e) => {
    setTarea(e.target.value);
  };

  const handleMarcaChange = (e) => {
    setMarca(e.target.value);
  };

  const handleFechaLimiteChange = (event) => {
    setFechaLimite(event.target.value);
  };

  const dispatch = useDispatch();

  const handleRegistroTarea = async (tarea) => {
    const currentTime = new Date().toISOString();

    await axios
      .post(`${BACKEND}/api/tareasregistro`, {
        tarea: tarea,
        estado: "pendiente",
        fecha: currentTime,
      })
      .then(({ data }) => dispatch(addTareaSuccess(data.register)))
      .catch((err) => console.log(err));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${BACKEND}/api/tareas`, {
        usuario: user.id,
        tarea: tarea,
        fecha_limite: fechaLimite,
        marca: marca,
        estado: "pendiente",
      });

      const nuevoTarea = response.data;
      console.log("Tarea añadido:", nuevoTarea);
      handleRegistroTarea(nuevoTarea);
      navigate("/home/tareas");
    } catch (error) {
      console.error("Error al añadir la tarea:", error);
      setErrorMessage("Error al añadir la tarea");
    }
  };

  return (
    <div className="flex items-center justify-center mt-12">
      <div className="bg-white rounded-lg p-8 shadow-md w-full max-w-md">
        <h2 className="text-2xl font-semibold mb-4">Añadir Tarea</h2>
        {errorMessage && (
          <div className="bg-red-200 text-red-800 py-2 px-4 mb-4 rounded">
            {errorMessage}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="mb-4 flex items-center">
            <p htmlFor="filtroFechaLimite" className="block mr-4">
              Fecha límite:
            </p>
            <input
              type="date"
              id="filtroFechaLimite"
              name="filtroFechaLimite"
              value={fechaLimite}
              onChange={handleFechaLimiteChange}
              className="w-40"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="tarea" className="block mb-2">
              Nombre de Tarea
            </label>
            <input
              type="text"
              id="tarea"
              value={tarea}
              onChange={handleTareaChange}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
              required
            />
          </div>
          <div className="mb-4">
            <label htmlFor="marca" className="block mb-2">
              Marca
            </label>
            <input
              type="text"
              id="marca"
              value={marca}
              onChange={handleMarcaChange}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:border-blue-500"
              required
            />
          </div>
          <div className="flex justify-end">
            <Link
              to="/home/tareas"
              type="button"
              className="px-4 py-2 mr-2 bg-gray-200 rounded"
              onClick={() => {
                console.log("Cancelado");
              }}
            >
              Cancelar
            </Link>
            <button
              type="submit"
              className="px-4 py-2 bg-[#ff6400] rounded text-white"
            >
              Añadir
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NuevaTarea;
